var d3 = {
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min")
};

var { makeTranslate, classify, formatStyle } = require("./lib/helpers");
var { isMobile } = require("./lib/breakpoints");

// Render a bar chart.
module.exports = function(config) {
  // Setup

  var { labelColumn, valueColumn, minColumn, maxColumn } = config;

  var barHeight = 30;
  var barGap = 30;
  var barTopOffset = config.showAxis ? 5 : 0;
  var labelWidth = 100;
  var labelMargin = 10;
  var valueMinWidth = 30;
  var dotRadius = 5;

  var margins = {
    top: config.showAxis ? 20 : 0,
    right: 20,
    bottom: 0,
    left: labelWidth + labelMargin
  };

  var ticksX = 10;

  // if (isMobile.matches) {
  //   ticksX = 6;
  //   margins.right = 30;
  // }

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight = barHeight + barGap;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  // Create D3 scale objects.
  var min = config.xMin;
  var max = config.xMax;

  var xScale = d3
    .scaleLinear()
    .domain([min, max])
    .range([0, chartWidth]);

  chartElement.append("rect")
    .attr("x", 0)
    .attr("y", 0 + barTopOffset)
    .attr("width", chartWidth)
    .attr("height", barHeight)
    .attr("class", `bg e-${ classify(config.valueColumn) }`);

  // Create D3 axes.
  var xAxis = d3
    .axisTop()
    .scale(xScale)
    .ticks(ticksX)
    .tickFormat(function(d,i) {
      if (i % 2 == 0) {
        return d + "%";
      }
    });

  // Render axes to chart.
  if (config.showAxis) {
    chartElement
      .append("g")
      .attr("class", "x axis")
      // .attr("transform", makeTranslate(0, chartHeight))
      .call(xAxis);
  }

  // Render grid to chart.
  chartElement
    .append("g")
    .attr("class", "x grid")
    // .attr("transform", makeTranslate(0, chartHeight))
    .call(
      xAxis
        .tickSize(-chartHeight, 0, 0)
        .tickFormat("")
    );

  // Render range bars to chart.
  // chartElement
  //   .append("g")
  //   .attr("class", "bars")
  //   .selectAll("line")
  //   .data(config.data)
  //   .enter()
  //   .append("line")
  //   .attr("x1", d => xScale(d[minColumn]))
  //   .attr("x2", d => xScale(d[maxColumn]))
  //   .attr("y1", (d, i) => i * (barHeight + barGap) + barHeight / 2)
  //   .attr("y2", (d, i) => i * (barHeight + barGap) + barHeight / 2);

  // render totals
  var totalData = config.data.filter(d => d["County Name"] == "Total");
  var totalValue = parseFloat(totalData[0][valueColumn]);
  var totalElement = chartElement.append("g")
    .attr("class", "state-total");
  totalElement.append("line")
    .attr("y1", barTopOffset)
    .attr("y2", barHeight + barTopOffset)
    .attr("x1", xScale(totalValue))
    .attr("x2", xScale(totalValue));
  totalElement.append("text")
    .attr("x", xScale(totalValue))
    .attr("y", barHeight + barTopOffset + 13)
    .text(`${ totalValue }%`);
  
  // Render dots to chart.
  chartElement
    .append("g")
    .attr("class", "dots")
    .selectAll("circle")
    .data(config.data)
    .enter()
    .append("circle")
      .attr("cx", d => xScale(parseFloat(d[valueColumn])))
      .attr("cy", function(d) {
        var yPos = (barHeight / 2) + barTopOffset;
        
        if (d["County Name"] == "Total") {
          yPos += 15;
        } else {
          yPos += getRandomArbitrary(-7,7);
        }

        // brown did better than obama in these counties
        // if (parseFloat(d["2012_diff"]) > 1) {
        //   yPos -= 10;
        // }

        return yPos;
      })
      .attr("r", function(d) {
        if (d["County Name"] == "Total") {
          return dotRadius - 2;
        } else {
          return dotRadius;
        }
      })
      .attr("class", function(d) {
        var c = classify(d["County Name"]);

        // style "total" circles differently
        if (d["County Name"] == "Total") {
          c + " total";
        }

        // var highlightRegions = [ "Southwest", "Southeast", "Northeast" ];
        // if (highlightRegions.includes(d["region"])) {
        //   c += "region ";
        // }

        // brown did better than obama in these counties
        if (parseFloat(d["2012_diff"]) > 1) {
          c += " region";
        }

        return c;
      })
      .on("mouseover", onDotHover)
      .on("mouseleave", onDotHoverOff);

  // Render bar labels.
  containerElement
    .append("ul")
    .attr("class", "labels")
    .attr(
      "style",
      formatStyle({
        width: labelWidth + "px",
        top: margins.top + "px",
        left: "0"
      })
    )
    .append("li")
    .attr("style", () =>
      formatStyle({
        width: labelWidth + "px",
        height: barHeight + "px",
        left: "0px",
        top: `${ barTopOffset + 1}px`
      })
    )
    .attr("class", d => `e-${ classify(config.valueColumn)}`)
    .append("span")
    .text(config.valueColumn);
  
  chartElement.append("text")
    .classed("tooltip", true);
  
  // // Render bar values.
  // ["shadow", "value"].forEach(function(cls) {
  //   chartElement
  //     .append("g")
  //     .attr("class", cls)
  //     .selectAll("text")
  //     .data(config.data)
  //     .enter()
  //     .append("text")
  //     .attr("x", d => xScale(d[maxColumn]) + 6)
  //     .attr("y", (d, i) => i * (barHeight + barGap) + barHeight / 2 + 3)
  //     .text(d => d[valueColumn].toFixed(1) + "%");
  // });
};

var onDotHover = function(evt) {
  var thisCounty = evt["County Name"];
  var thisDot = d3.select(this);
  var thisTooltip = this.closest("svg").querySelector("text.tooltip");
  thisTooltip.innerHTML = `${ evt["County Name"] }`;
  thisTooltip.setAttribute("x", Math.ceil(d3.select(this).attr("cx")) + 10);
  thisTooltip.setAttribute("y", Math.ceil(d3.select(this).attr("cy")) + 3);

  document.querySelectorAll(`.${ classify(thisCounty )}`).forEach(d => d.classList.add("hover"));
}
var onDotHoverOff = function(evt) {
  document.querySelectorAll("text.tooltip").forEach(d => d.innerHTML = "");
  document.querySelectorAll(".hover").forEach(d => d.classList.remove("hover"));
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}